export default "__VITE_ASSET__DohN3bK7__"